import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ "menu" ]

  toggle (e) {
    this.menuTarget.classList.toggle('hidden')
  }
}
